import React from 'react';
export default function CircleCrewCut({ light }) {
  return (
<><path d="M17.069 2.638c-5.194.007-9.48 4.078-9.77 9.28.216-.556 1.214-2.34 2.425-3.554 1.25-1.253 3.022-2.053 3.022-2.053s1.611 1.187 4.31 1.173c2.434-.012 4.676-1.158 4.676-1.158s1.539.652 2.655 2.009c1.064 1.294 2.111 2.4 2.411 3.089-.53-4.992-4.725-8.78-9.73-8.786z" fill={light}/></>); }
